module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "top",
    style: ({
      backgroundImage: ("url(" + (_vm.userData.avatar) + ")")
    })
  }, [_c('mu-appbar', {
    attrs: {
      "title": "name",
      "zDepth": 0
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.showPersonindex_x
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-top",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "more_vert"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "c"
  }, [_c('mu-avatar', {
    attrs: {
      "src": _vm.userData.avatar,
      "size": 96
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userData.name))])], 1), _vm._v(" "), _c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "TAB ONE"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "TAB TWO"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab3",
      "title": "TAB ACTIVE"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.activeTab === 'tab1') ? _c('div', [_c('mu-list-item', {
    attrs: {
      "title": "Phone",
      "describeText": _vm.userData.phone,
      "disabled": ""
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "voicemail",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [(_vm.activeTab === 'tab1') ? _c('div', [_c('mu-list-item', {
    attrs: {
      "title": "Region",
      "describeText": _vm.userData.address,
      "disabled": ""
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "location_on",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [(_vm.activeTab === 'tab1') ? _c('div', [_c('mu-list-item', {
    attrs: {
      "title": "Birthday",
      "describeText": _vm.userData.birthday,
      "disabled": ""
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "cake",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('div', [_c('h1', [_vm._v("制作中....")])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab3') ? _c('div', [_c('h1', [_vm._v("未完待续....")])]) : _vm._e()]), _vm._v(" "), _c('mu-tabs', {
    staticClass: "bottom"
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "icon": "videocam"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "icon": "phone",
      "color": "#f00"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab3",
      "icon": "chat_bubble"
    },
    on: {
      "click": _vm.showDialog_x
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3861eec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personindex/personindex.vue
// module id = 530
// module chunks = 1